var app = angular.module("leonardo");

var DeleteUnitDialog = function($scope, UnitService, FormErrorsService) {
  $scope.filters = $scope.ngDialogData.filters;
  
  $scope.delete = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    UnitService.deleteAll($scope.filters).then(function() {
      $scope.confirm();
    }, function () {
      $scope.closeThisDialog();
    });
  };

  $scope.undelete = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    UnitService.unDeleteAll($scope.filters).then(function() {
      $scope.confirm();
    }, function () {
      $scope.closeThisDialog();
    });
  };

};

app.controller('DeleteUnitDialog', ['$scope', 'UnitService', 'FormErrorsService', DeleteUnitDialog]);
